module.exports = __webpack_public_path__ + "static/media/linux.c714400b.svg";